<template>
    <section class="proc-column" :class="{ 'proc-column--expanded': expanded }">
        <div class="column-header">
            <div>
                <h3>{{ title }}</h3>
                <span v-if="subtitle">{{ subtitle }}</span>
            </div>

            <button
                class="btn-small proc-btn proc-btn-toggle"
                type="button"
                @click="$emit('toggle-expand')"
            >
                {{ expanded ? 'Recolher' : 'Expandir' }}
            </button>
        </div>

        <slot />
    </section>
</template>

<script setup>
defineProps({
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    expanded: { type: Boolean, default: false },
});

defineEmits(['toggle-expand']);
</script>
